import { Suspense, lazy, useState } from 'react';
import cn from 'classnames';
import { CarleadLayout, useCarleadConfiguration } from '@wkda/carlead-creation-components';
import { useTrackLanding } from '@wkda/funnel-components';
import { ConversationalLeadPricedTitle, MultiModeCarleadCreation } from '@wkda/conversational-carlead';
import { useTrackElementClick } from '../../../hooks/useTrackElementClick';
import { CarleadStepCompoundBuyCar } from '../form/single-step/CarleadStepCompoundBuyCar';
import CarleadHIWWhyChooseWkdaFaq from '../content/CarleadHIWWhyChooseWkdaFaq';
import TrustPilot from '../../../components/appointment/TrustPilot';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ConversationalCarleadChat = /*#__PURE__*/lazy(() => import('@wkda/conversational-carlead').then(m => ({
  default: m.ConversationalCarleadChat
})));
const chatComponentLoader = () => import('@wkda/conversational-carlead').then(m => ({
  default: m.ConversationalCarleadChat
}));
const BaseConversationalLeadPage = ({
  form,
  customFlow,
  answerFieldQuestion,
  showTerms,
  manualForm,
  blue = false,
  titleComponent: TitleComponent = ConversationalLeadPricedTitle,
  modeToggleClassName: modeToggleClassNameProp,
  content: ContentComponent = CarleadHIWWhyChooseWkdaFaq,
  showTrustPilotInChat = false,
  leftActions = null,
  rightActions = null,
  onCarleadCreationError = {},
  ...contentProps
}) => {
  useTrackLanding();
  const {
    marketingAttributes
  } = useCarleadConfiguration();
  const [mode, setMode] = useState('manual');
  const modeToggleClassName = modeToggleClassNameProp === undefined ? 'conversational-lead__mode-toggle' : modeToggleClassNameProp;
  function onModeChange(prevMode, newMode) {
    if (newMode === 'chat' && prevMode === 'manual') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      marketingAttributes['lead-conversational-lead-toggle'] = 1;
    } else {
      marketingAttributes['lead-conversational-lead-toggle'] = 0;
    }
    setMode(newMode);
  }
  const trackTextareaClick = useTrackElementClick({
    label: 'Conversational Lead - Chat',
    category: 'lead',
    action: 'Click'
  });
  const handleTextareaFocus = e => {
    if (e.target.tagName === 'TEXTAREA') {
      trackTextareaClick();
    }
  };
  return /*#__PURE__*/_jsxs(CarleadLayout, {
    containerClassName: cn('conversational-lead-main carlead-redesign', {
      'carlead-redesign-blue': blue
    }, {
      'conversational-lead-main--chat-mode': mode === 'chat'
    }),
    customBanner: null,
    modernLayout: true,
    emailSubscriptionExcluded: mode === 'chat',
    children: [/*#__PURE__*/_jsxs("div", {
      className: "conversational-lead__page-content",
      onFocusCapture: handleTextareaFocus,
      children: [/*#__PURE__*/_jsx(TitleComponent, {}), /*#__PURE__*/_jsx(MultiModeCarleadCreation, {
        initialMode: "manual",
        alternativeFormLoader: chatComponentLoader,
        outerClassName: modeToggleClassName,
        renderChat: ({
          isLoading
        }) => /*#__PURE__*/_jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/_jsx(ConversationalCarleadChat, {
            disabled: isLoading,
            flow: customFlow ? customFlow(form) : form,
            answerFieldQuestion: answerFieldQuestion,
            leftActions: leftActions,
            rightActions: rightActions,
            onCarleadCreationError: onCarleadCreationError
          })
        }),
        renderManualForm: () => /*#__PURE__*/_jsx("div", {
          className: "conversational-lead__manual-form-wrapper",
          children: manualForm ?? /*#__PURE__*/_jsx(CarleadStepCompoundBuyCar, {
            showTerms: showTerms
          })
        }),
        onModeChange: onModeChange
      }), showTrustPilotInChat && mode === 'chat' ? /*#__PURE__*/_jsxs("section", {
        className: "trust-box",
        children: [/*#__PURE__*/_jsx("div", {
          className: "d-none d-md-block",
          children: /*#__PURE__*/_jsx(TrustPilot, {
            type: "lead",
            screen: "desktop"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "d-block d-md-none",
          children: /*#__PURE__*/_jsx(TrustPilot, {
            type: "lead",
            screen: "mobile"
          })
        })]
      }) : null]
    }), /*#__PURE__*/_jsx("div", {
      className: "conversational-lead__content-sections",
      children: /*#__PURE__*/_jsx(ContentComponent, {
        withLayout: false,
        ...contentProps
      })
    })]
  });
};
export default BaseConversationalLeadPage;